import { render, staticRenderFns } from "./BoardMember.vue?vue&type=template&id=a6fa7988&"
import script from "./BoardMember.vue?vue&type=script&lang=js&"
export * from "./BoardMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports